import I1 from "../img/i1.png";
import F1 from "../img/f1.png";
import C3 from "../img/c3.png";
import FI1 from "../img/fi1.png";

export const heroData = [
  {
    id: 1,
    name: "P2 Phonendoscope",
    imageSrc: I1,
    desc: "",
    price: "80,000",
  },
  {
    id: 2,
    name: "X-Ray Machine",
    imageSrc: F1,
    desc: "",
    price: "6,40,000",
  },
  {
    id: 3,
    name: "Ultra Sonography",
    imageSrc: C3,
    desc: "",
    price: "4,65,000",
  },
  {
    id: 4,
    name: "V6 Ventilator",
    imageSrc: FI1,
    desc: "",
    price: "7,35,000",
  },
];

export const categories = [
  {
    id: 1,
    name: "Dialysis",
    urlParamName: "dialysis",
  },
  {
    id: 2,
    name: "Ventilator",
    urlParamName: "ventilator",
  },
  {
    id: 3,
    name: "Radiology",
    urlParamName: "radiology",
  },
  {
    id: 4,
    name: "Infusion Pump",
    urlParamName: "pumps",
  },
  {
    id: 5,
    name: "Anesthesiology",
    urlParamName: "anesthesiology",
  },
];
